/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:54:58
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:05:35
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\testee\state.js
 */
import * as STATETYPES from '../stateTypes'
const state = {
	[STATETYPES.TESTEEDETAIL]: {}, // 受试者详情
	[STATETYPES.TESTEEFORM]: {} // 受试者表单
}
export default state